<template>
  <div class="embed-container">
    <div v-if="loading" class="embed-loading">
      <a-spin size="large" />
      <p class="embed-loading-text">{{ $t('第三方免登.正在免密登录') }}</p>
    </div>
    <a-result v-else status="error" :title="$t('第三方免登.免登失败')" :sub-title="errorMsg">
      <template #extra>
        <a-button type="primary" @click="toLogin">
          {{ $t('第三方免登.前往登录') }}
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { setToken } from '@/utils/auth'
import { embedLogin } from '@/api/login'

/**
 * 第三方系统免登落地页
 *
 * 访问路径：/embed?ticket=xxx
 * ticket 由第三方系统服务端调用 /embed/ticket 获取，一次性且5分钟内有效。
 * 跳转地址由服务端在签发 ticket 时校验后返回，前端不自行传入 redirect，避免开放重定向。
 */
export default {
  name: 'EmbedLogin',
  data () {
    return {
      loading: true,
      errorMsg: ''
    }
  },
  created () {
    const ticket = this.$route.query.ticket
    if (!ticket) {
      this.fail(this.$t('第三方免登.凭证缺失提示'))
      return
    }
    embedLogin(ticket).then(res => {
      const data = res && res.data ? res.data : null
      if (!data || !data.token) {
        this.fail(this.$t('第三方免登.失败提示'))
        return
      }
      // 与 store/modules/user.js 的 Login 保持完全一致的写入方式
      storage.set(ACCESS_TOKEN, data.token, 7 * 24 * 60 * 60 * 1000)
      setToken(data.token)
      this.$router.replace({ path: this.safeRedirect(data.redirect) })
    }).catch(err => {
      this.fail((err && err.message) || this.$t('第三方免登.失败提示'))
    })
  },
  methods: {
    // 兜底校验，异常值时回落到首页
    safeRedirect (redirect) {
      if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) {
        return '/index'
      }
      return redirect
    },
    fail (msg) {
      this.loading = false
      this.errorMsg = msg
    },
    toLogin () {
      this.$router.replace({ path: '/user/login' })
    }
  }
}
</script>

<style lang="less" scoped>
.embed-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.embed-loading {
  text-align: center;
}

.embed-loading-text {
  margin-top: 16px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
